import React, { useEffect, useState } from 'react';
import { ResponsiveContainer, ComposedChart, Area, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { TrendingUp, Loader2 } from 'lucide-react';
import { adminAPI } from '../services/api';

// Admin › Paramètres › Suivi d'indexation : évolution hebdomadaire du nombre de pages indexées (photo prise après chaque vérification)
export const SeoIndexationHistory = ({ refreshKey }) => {
  const [weeks, setWeeks] = useState(26);
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); adminAPI.seoIndexationHistory(weeks).then(setData).catch(() => setData({ weeks: [] })); }, [weeks, refreshKey]);
  const rows = (data?.weeks || []).map((w) => ({ ...w, label: w.week.slice(5), problems: (w.not_indexed || 0) + (w.unknown || 0), rate: w.checked ? Math.round((w.indexed / w.checked) * 100) : 0 }));
  const latest = data?.latest;
  return (
    <div className="mt-5 border-t pt-4" data-testid="seo-indexation-history">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <div>
          <h3 className="font-semibold text-gray-900 flex items-center gap-2 text-sm"><TrendingUp size={15} className="text-orange-500" /> Historique d'indexation</h3>
          <p className="text-xs text-gray-500" data-testid="seo-indexation-history-summary">{latest ? <>Semaine {latest.week} : <strong>{latest.indexed}</strong> indexée(s) sur {latest.checked} vérifiée(s) ({latest.total} suivies) · {data.delta_indexed >= 0 ? '+' : ''}{data.delta_indexed} sur la période · record {data.best}</> : 'Une photo est prise à chaque vérification (lundi 9h ou manuelle), une par semaine.'}</p>
        </div>
        <select value={weeks} onChange={(e) => setWeeks(Number(e.target.value))} className="text-sm border border-gray-200 rounded-md py-1.5 px-2 bg-white" data-testid="seo-indexation-history-weeks">
          {[8, 12, 26, 52].map((n) => <option key={n} value={n}>{n} semaines</option>)}
        </select>
      </div>
      {!data ? <div className="flex justify-center py-6"><Loader2 className="animate-spin text-orange-500" /></div> : rows.length < 1 ? (
        <p className="text-sm text-gray-500 py-4 text-center border rounded-lg" data-testid="seo-indexation-history-empty">Pas encore d'historique : lancez « Vérifier l'indexation » (ou attendez lundi) pour la première photo.</p>
      ) : (
        <div data-testid="seo-indexation-history-chart">
          <ResponsiveContainer width="100%" height={220}>
            <ComposedChart data={rows} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
              <XAxis dataKey="label" tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip labelFormatter={(l, p) => (p?.[0]?.payload?.week ? `Semaine ${p[0].payload.week}` : l)} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Area type="monotone" dataKey="total" name="Pages suivies" stroke="#cbd5e1" fill="#f1f5f9" />
              <Line type="monotone" dataKey="indexed" name="Indexées" stroke="#16a34a" strokeWidth={2.5} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="problems" name="Non indexées / inconnues" stroke="#dc2626" strokeWidth={1.5} dot={{ r: 2 }} />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-gray-500 mt-1">
            {rows.slice(-6).map((w) => <span key={w.week} data-testid={`seo-indexation-history-week-${w.week}`}>{w.week.slice(5)} : <span className="text-green-700 font-medium">{w.indexed}</span>/{w.checked} ({w.rate} %)</span>)}
          </div>
        </div>
      )}
    </div>
  );
};

export default SeoIndexationHistory;
